import styled from 'styled-components';

export const HighlightedCopyWrapper = styled.div<StyleProps>`
  padding: 16px;
  margin-bottom: 16px;
  border-radius: ${props => props.theme.borderRadii.small};
  background-color: ${props => props.theme.colors.background.secondary};
`;
